import { render, staticRenderFns } from "./Playground.vue?vue&type=template&id=2b8f9536&scoped=true&"
import script from "./Playground.vue?vue&type=script&lang=js&"
export * from "./Playground.vue?vue&type=script&lang=js&"
import style0 from "./Playground.vue?vue&type=style&index=0&id=2b8f9536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8f9536",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b8f9536')) {
      api.createRecord('2b8f9536', component.options)
    } else {
      api.reload('2b8f9536', component.options)
    }
    module.hot.accept("./Playground.vue?vue&type=template&id=2b8f9536&scoped=true&", function () {
      api.rerender('2b8f9536', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Playground/Playground.vue"
export default component.exports